import { Box, Button, Card, Flex } from '@chakra-ui/react'
import type { InsuranceParamsPagedQuery } from 'BrokerTsLib/src/dtos'
import { createContext, useEffect, useState } from 'react'

import { ConceptsTravelSearch } from '@/containers/search/ConceptsTravelSearch'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { ConceptsList } from '../../containers/concepts/ConceptsList'
import { DashboardHeader } from '../../containers/dashboard/DashboardHeader'
import { PageToolbar } from '../../containers/PageToolbar'
import { SearchButton } from '../../containers/search/SearchButton'
import { WithAuth } from '../../hoc/WithAuth'
import { useGetAll } from '../../hooks/useInsuranceParams'
import { PageWrapper } from '../../layouts/components/PageWrapper'

export const conceptsTravelContext = createContext<
  IPaginationContext<InsuranceParamsPagedQuery>
>({} as IPaginationContext<InsuranceParamsPagedQuery>)

const ConceptsTravelPageComponent = () => {
  const [isOpen, setOpen] = useState(false)
  const [allowSelect, setAllowSelect] = useState(false)

  const [deletedCounter, setDeletedCounter] = useState(0)
  const [filter, setFilter] =
    useSearchParamsStatePersistance<InsuranceParamsPagedQuery>(
      {
        listType: 1,
        pageIndex: 1,
        pageSize: 10,
      },
      ['listType'],
    )

  const { data, mutateAsync: getAllAsync, isLoading: isLoading } = useGetAll()
  const items = data?.data

  const reloadData = () => setDeletedCounter(deletedCounter + 1)

  useEffect(() => {
    if (filter.pageSize)
      // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter, deletedCounter])

  return (
    <PageWrapper
      header={<DashboardHeader title="Rozpracované nabídky" />}
      mainProps={{ sx: { pt: { base: 0, md: 8 }, gap: 4, display: 'grid' } }}
    >
      <PageToolbar
        rightElements={
          <Flex sx={{ gap: 4 }}>
            <Button variant="ghost" onClick={() => setAllowSelect(!allowSelect)}>
              {/* <Select color="secondary.500" /> */}
              {allowSelect ? 'Zrušit smazání' : 'Vybrat ke smazání'}
            </Button>
            <SearchButton isOpen={isOpen} toggleOpen={() => setOpen(!isOpen)} />
          </Flex>
        }
      />
      <conceptsTravelContext.Provider
        value={{
          loading: isLoading,
          totalCount: items?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? 10,
          filter: filter,
          setCurrentPage: (p: number) => setFilter({ ...filter, pageIndex: p }),
          setPageSize: (s: number) => setFilter({ ...filter, pageSize: s }),
          updateFilter: setFilter,
          reload: reloadData,
        }}
      >
        {isOpen && <ConceptsTravelSearch />}

        <Card>
          <Box
            sx={{
              display: 'grid',
              gap: 8,
              placeItems: 'start',
              justifyItems: 'stretch',
            }}
          >
            <ConceptsList
              concepts={items?.items ?? []}
              withPaginator
              allowSelect={allowSelect}
            />
          </Box>
        </Card>
      </conceptsTravelContext.Provider>
    </PageWrapper>
  )
}

export const ConceptsTravelPage = WithAuth(ConceptsTravelPageComponent)
